/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_CODE,
  screenData: data,
});

export const setPaginationIndex = (value) => ({
  type: actionTypes.SET_PAGINATION_INDEX_DISPUTE_CODES,
  payload: value,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_CODE,
  detailScrData: data,
});

export const dispatchMfgSelected = (payload) => ({
  type: actionTypes.SEARCH_MFG_DISP_ACTIVITY,
  payload,
});

// dispatch Quarter From

export const dispatchQtrRange = (data) => ({
  type: actionTypes.SET_QUARTER_RANGE_CODE,
  payload: data,
});
// Manufacturer Display
export const getManufactureOption = (value) => ({
  type: actionTypes.SELECT_MANUFACTURER_CODE,
  manufactureCode: value,
});
// Manufacturer Name Display
export const getManufactureName = (value) => ({
  type: actionTypes.GET_MANUFACTURER_NAME_CODE,
  allManufacturer: value,
});
// Manufacturer ID display
export const getManufactureID = (value) => ({
  type: actionTypes.GET_MANUFACTURER_ID_CODE,
  manufactureWithIds: value,
});
// Manufacturer Name Display
export const dispatchCodeName = (value) => ({
  type: actionTypes.GET_CODE_NAME_CODE,
  allCode: value,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_CODE,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgDisputeCode = (data) => ({
  type: actionTypes.GET_ERROR_MSG_DISPUTE_CODE,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgDisputeCode([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgDisputeCode([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// dispatch Display screen Object
export const dispatchDisplayObjCodes = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_CODE,
  payload: data,
});

//  table grid dispatch function
export const dispatchDisputeCodeReport = (data) => ({
  type: actionTypes.GET_DISPUTE_CODE_REPORT,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_CODE,
  payload: data,
});
// rebate program Name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_CODE,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

// status dispatch
export const dispatchStatus = (data) => ({
  type: actionTypes.SET_STATUS_CODE,
  payload: data,
});
// selected Code dispatch
export const dispatchSelectedCode = (data) => ({
  type: actionTypes.SELECTED_DISPUTE_CODE,
  payload: data,
});

// selected code option dispatch
export const dispatchSelectedCodeOption = (data) => ({
  type: actionTypes.SELECT_DISPUTE_CODE_OPTION,
  payload: data,
});
// drug selected dispatch
export const dispatchSelectedDrug = (data) => ({
  type: actionTypes.GET_DRUG_SELECTION,
  payload: data,
});
// refresh data
export const refreshDisputeCode = () => ({
  type: actionTypes.SET_REFRESH_DATA_CODE,
  payload: {},
});
export const refreshDisputeCodeDisplay = () => ({
  type: actionTypes.REFRESH_DISPUTE_CODE_DISPLAY,
  payload: {},
});
// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      return dispatch({
        type: actionTypes.MANUFACTURER_GRID_CODE,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch([]);
      return response;
    });
};

// selected code
export const getSelectedCode = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return dispatch(dispatchSelectedCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSelectedCode([]));
    });
};
// dispute code report
export const getDisputeCodeReport = (value) => (dispatch) => {
  dispatch(dispatchDisputeCodeReport([]));
  return axios
    .post(serviceEndPoint.GET_DISPUTE_CODE, value)
    .then((response) => {
      if (response.data.disputeCodeReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchDisputeCodeReport(response.data));
        return response.data;
      }
    })
    .catch((response) => {
      dispatch(dispatchDisputeCodeReport([]));
    });
};
// export all
export const setExportAll = (data, key) => ({
  type: actionTypes.SET_EXPORT_ALL_CODE,
  payload: { data, key },
});
export const reportData = (value, i) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DISPUTE_CODE, value)
    .then((response) => {
      dispatch(setExportAll(response?.data?.disputeCodeReportVO, i));
    })
    .catch((response) => {
      dispatch(setExportAll([], i));
    });
};
function divideArray(array, parts) {
  const { length } = array;
  let adjustedLength = length;

  if (length % parts !== 0) {
    adjustedLength = length + (parts - (length % parts));
  }

  const partSize = adjustedLength / parts;
  const dividedParts = [];
  let currentIndex = 0;

  for (let i = 0; i < parts; i++) {
    const part = array.slice(currentIndex, currentIndex + partSize);
    dividedParts.push(part);
    currentIndex += partSize;
  }

  return dividedParts;
}
export const getCodeExportAll =
  (
    {
      programCd,
      mfgId,
      mfgType,
      beginQtr,
      endQtr,
      adjustDisputeCd,
      disputeType1Cd,
      disputeType2Cd,
      openStatus,
      closeStatus,
      shortDescrition,
    },
    selectedDisputeCodeOptionList
  ) =>
  (dispatch) => {
    dispatch(setExportAll({}));
    const allCodeTemp = selectedDisputeCodeOptionList?.map(
      (item) => item.codeValuetemp
    );
    let allDescTemp = selectedDisputeCodeOptionList?.map(
      (item) => item.shortDescrition
    );

    const arr = divideArray(allCodeTemp, 2);
    const descArr = divideArray(allDescTemp, 2);
    for (let i = 0; i < arr.length && i < descArr.length; i++) {
      const values = {
        programCd,
        mfgId,
        mfgType,
        beginQtr,
        endQtr,
        adjustDisputeCd,
        adjustDisputeCd: arr[i],
        disputeType1Cd,
        disputeType2Cd,
        openStatus,
        closeStatus,
        shortDescrition,
        shortDescrition: descArr[i],
      };

      dispatch(reportData(values, i));
    }
  };
